// react
import { useEffect, useState } from "react";

// formik
import { useFormik } from "formik";

// componets seplag
import RotuloSeplag from "./../../../components/RotuloSeplag/index";

// global
import { classNames, isFormFieldValid, getFormErrorMessage, printToast, summaryCriacaoSucessoPadrao, detailCriacaoSucessoPadrao, summaryAlteracaoSucessoPadrao, detailAlteracaoSucessoPadrao } from "../../../config/global";

// components primereact
import { InputText } from "primereact/inputtext";
import ModalSeplag from "./../../../components/ModalSeplag/index";

// service tipoAto
import { pesquisarAllTipoAto as pesquisarAllTipoAto } from "../../../service/cadastroTipoAto";
import { Form as initForm } from "../../../service/cadastroTipoAto";
import { criar as criarCadastroTipoAto, atualizar as atualizarCadastroTipoAto, remover as RemoverCadastroTipoAto } from "../../../service/cadastroTipoAto";
import { Button } from "primereact/button";

const Index = ({ handleCloseModalAdicionarTipoCertidao, formEdit, showForm, setShowForm, edit, onSalvar }) => {
  const [optionsDescTipoAto, setOptionsDescTipoAto] = useState([]);
  const [formEditAmparo, setFormEditAmparo] = useState(initForm);

  useEffect(() => {
    if (edit) {
      setFormEditAmparo({
        ...formEdit,
        descTipoAto: optionsDescTipoAto.length > 0 ? optionsDescTipoAto[0] : null,
      });
    }
  }, [optionsDescTipoAto, edit, formEdit]);

  useEffect(() => {
    pesquisarAllTipoAto().then((res2) => {
      setOptionsDescTipoAto(res2);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formEditAmparo,
    validate: (data) => {
      let errors = {};
      if (!data.descTipoAto) {
        errors.descTipoAto = "O Tipo de Ato administrativo é de preenchimento obrigatório";
      }

      if (!data.siglTipoAto) {
        errors.numrAto = "A sigla do ato é de preenchimento obrigatório";
      }

      return errors;
    },
    onSubmit: async (data) => {
      let dadosCriacao = {
        descTipoAto: data.descTipoAto,
        siglTipoAto: data.siglTipoAto,
      };

      let dadosAtualizacao = {
        idenAmparoLegal: formEdit?.idenAmparoLegal,
        orgao: data.orgao,
        tipoAto: data.descTipoAto,
        numrAto: data.numrAto,
        numrAnoAto: data.numrAnoAto,
        dataPublicacaoAto: data.dataPublicacaoAto,
        descComplementoAmparo: data.descComplementoAmparo,
        dataInicioVigencia: data.dataInicioVigencia,
        dataTerminoVigencia: data.dataTerminoVigencia,
        statusAmparoLegal: data.statusAmparoLegal,
        descAmparoLegal: data.descAmparoLegal,
      };

      if (edit) {
        await atualizarCadastroTipoAto(dadosAtualizacao.idenAmparoLegal, dadosAtualizacao).then((res) => {
          let summary;
          let detail;

          if (res.type === "INS") {
            summary = summaryCriacaoSucessoPadrao;
            detail = detailCriacaoSucessoPadrao;
          } else {
            summary = summaryAlteracaoSucessoPadrao;
            detail = detailAlteracaoSucessoPadrao;
          }
          printToast({ summary, detail });
          setShowForm(false);
          onSalvar && onSalvar();
        });

        setShowForm(false);
      } else {
        await criarCadastroTipoAto(dadosCriacao).then((res) => {
          onSalvar && onSalvar();

          let summary;
          let detail;

          if (res.type === "INS") {
            summary = summaryCriacaoSucessoPadrao;
            detail = detailCriacaoSucessoPadrao;
          } else {
            summary = summaryAlteracaoSucessoPadrao;
            detail = detailAlteracaoSucessoPadrao;
          }
          printToast({ summary, detail });
          setShowForm(false);
        });
      }
    },
  });

  // fechar modal
  function handlerHide() {
    formik.resetForm();
    setShowForm(false);
  }

  return (
    <ModalSeplag titulo={"Tipo Ato"} visible={showForm} type="NONE" edit={edit} fechar={handlerHide} onClick={handlerHide} tamanho="70vw">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-grid">
          <RotuloSeplag nome="Tipo Ato Adminstrativo" obrigatorio cols="12 6 6">
            <InputText
              id="descTipoAto"
              name="descTipoAto"
              options={optionsDescTipoAto}
              value={formik.values.descTipoAto}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              placeholder="Acórdão, Decreto..."
              className={classNames({ "p-invalid": isFormFieldValid("descTipoAto", formik) })}
            />
            {getFormErrorMessage("descTipoAto", formik)}
          </RotuloSeplag>

          <RotuloSeplag nome="Sigla do Ato" cols="12 6 6" obrigatorio>
            <InputText id="siglTipoAto" name="siglTipoAto" value={formik.values.siglTipoAto} className={classNames({ "p-invalid": isFormFieldValid("siglTipoAto", formik) })} onChange={(e) => formik.handleChange(e)} />
            {getFormErrorMessage("siglTipoAto", formik)}
          </RotuloSeplag>
          <div className="p-grid" style={{ marginTop: "20px", width: "600px" }}>
            <div className="p-col-12 p-md-3">
              <Button label={edit ? "Editar" : "Enviar"} icon={edit ? "pi pi-pencil" : "pi pi-check"} autoFocus className="p-button-raised margin-app-entre-button" type="submit" />
            </div>
            <div className="p-col-12 p-md-3">
              <Button type="button" label="Cancelar" icon="pi pi-times" onClick={handlerHide} className="p-button-outlined p-button-danger p-mb-1" />
            </div>
          </div>
        </div>
      </form>
    </ModalSeplag>
  );
};

export default Index;
